
import { PageRequest } from "@/store/shared/entity";
import CreateRole from "./component/create-role.vue";
import EditRole from "./component/edit-role.vue";

import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins, PageResultListMixins } from "@/lib";

class PageRoleRequest extends PageRequest {
  name: string;
}

@Component({
  name:"role.list", //设置页面对应route的名字，以便keepalive进行缓存
  components: { CreateRole, EditRole }
})
export default class Roles extends Mixins(PageResultBaseMixins, PageResultModalMixins, PageResultListMixins) {
  /**
   * section buttons
   */
  sectionButtons = { ...this.addBtn() };

  /**
   * search-page bind data
   */
  data: any = {
    model: new PageRoleRequest(),
    queryAction: "system/role/getAll",
    isAutoQuery: true,
    cols: this.columns
  };

  /**
   * table columns
   */
  get columns() {
    return [
      { title: this.L("Roles.Name"), key: "name"},
      { title: this.L("Roles.Description"), key: "description", tooltip: true },
      this.$util.render.actions(this.colButtons)
    ];
  }

  colButtonCheck = (row)=>{
    return !row.isStatic;
  }

  /**
   * table 操作列按钮
   */
  get colButtons(): ActionButtonConfig[] {
    return [
        this.colEditBtnM(row => this.colButtonCheck(row)),
        this.colCommonBtnP("Action.SetPermission", "Pages.Roles.SetPermission", "role.setPermission", row => this.colButtonCheck(row)),
        this.colDeleteBtn(row => this.colButtonCheck(row))
    ];
  }

  /**
   * reset 回调
   */
  reset() {
    this.data.model = new PageRoleRequest();
  }
}
